<mat-nav-list>
    @if (options.remove) {
        <a (click)="openLink('remove')" mat-list-item>
            <mat-icon class="fas fa-trash" mat-list-icon></mat-icon>
            <span mat-line>Verwijder foto</span>
        </a>
    }
    @if (options.rotate) {
        <a (click)="openLink('rotate')" mat-list-item>
            <mat-icon class="fas fa-rotate-left" mat-list-icon></mat-icon>
            <span mat-line>Foto draaien</span>
        </a>
    }
    <a (click)="openLink('gallery')" mat-list-item>
        <mat-icon class="fas fa-image" mat-list-icon></mat-icon>
        <span mat-line>Galerij</span>
    </a>
    <a (click)="openLink('camera')" mat-list-item>
        <mat-icon class="fas fa-camera" mat-list-icon></mat-icon>
        <span mat-line>Camera</span>
    </a>
</mat-nav-list>
